import { render, staticRenderFns } from "./ProviderInfo.vue?vue&type=template&id=13a1d69b&"
import script from "./ProviderInfo.vue?vue&type=script&lang=js&"
export * from "./ProviderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports